import { BusinessCentres, Role } from '@cambridgeassessment/lib-ee-commons';
import {
  SET_AVAILABLE_BUSINESS_UNITS,
  SET_BUSINESS_UNIT,
  SET_USER_SELECTED_ROLE,
  SetAvailableBusinessUnits,
  SetBusinessUnit,
  SetUserSelectedRole,
} from './types';

export const setUserSelectedRole = (userSelectedRole: Role): SetUserSelectedRole => ({
  type: SET_USER_SELECTED_ROLE,
  payload: userSelectedRole,
});

export const setBusinessUnit = (businessUnit: BusinessCentres): SetBusinessUnit => ({
  type: SET_BUSINESS_UNIT,
  payload: {
    businessUnit,
  },
});

export const setAvailableBusinessUnits = (businessUnits: BusinessCentres[]): SetAvailableBusinessUnits => ({
  type: SET_AVAILABLE_BUSINESS_UNITS,
  payload: {
    businessUnits,
  },
});

export default {
  setUserSelectedRole,
  setBusinessUnit,
  setAvailableBusinessUnits,
};
